import useAxios from 'hooks/useAxios';

export async function editBanner(id, actionRedirectLink) {
  const api = useAxios();
  const payload = {
    actionRedirectLink
  };

  try {
    const res = await api.patch(`/banners/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
}


